<template>
    <ui-modal :name="$mx_getModalName" title="Chamar Próximo Cliente" icon="fal fa-users-class">
        <div class="container-content-call-customer">
            <div v-if="load" class="box">
                <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
            </div>           

            <div v-else class="content-call-customer">
                <div class="tag-indicator">
                    <ui-tag-indicator color="#1cca85" :text="deal.id" />
                </div>

                <div class="cliente-responsible">
                    <div class="icon-user">
                        <em class="fal fa-user-circle" />
                    </div>

                    <div class="name-data-user">
                        <div class="name-user">{{ deal.customer.name }}</div>

                        <div v-if="deal.customer.cpf" class="data-user">
                            {{ deal.customer.cpf | documentBr }}
                        </div>
                    </div>

                    <div class="phone-whatsapp">
                        <div class="phone">
                            <div class="icon-phone">
                                <em class="fal fa-phone-alt" />
                            </div>

                            <div v-if="deal.customer.mobile || deal.customer.phone" class="phone-number">
                                {{ (deal.customer.phone || deal.customer.mobile) | phoneMask }}
                            </div>
                            <span v-else>-</span>
                        </div>

                        <div class="whatsapp">
                            <div class="icon-whatsapp">
                                <em class="fab fa-whatsapp" />
                            </div>

                            <div v-if="deal.customer.mobile" class="whatsapp-number">
                                {{ deal.customer.mobile | phoneMask }}
                            </div>
                            <span v-else>-</span>
                        </div>
                    </div>

                    <div v-if="responsible" class="responsible">
                        <div class="text-responsible"/>
                        <ui-popover trigger="hover">
                            <template #target>
                                <div class="popover-target-name">
                                    Responsável
                                </div>
                            </template>
                            <template #content>
                                <div class="info">
                                    <div v-if="responsible.users.length > 0">
                                        <h2 class="team" :title="responsible.team">{{responsible.team}}</h2>
                                        <div class="table">
                                            <div class="column title">
                                                <span>Usuário</span>
                                                <span>Nome</span>
                                                <span>Telefone</span>
                                            </div>
                                            <div v-for="(user, index) in responsible.users" :key="index" class="column">
                                                <div class="title no-color">{{user.group}}</div>
                                                <div :title="user.name">{{user.name}}</div>
                                                <div :title="user.tel">{{user.tel}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="info-responsible" :style="responsible.users.length > 0 ? '' : 'margin-bottom: 15px;'">
                                        <div class="name">
                                            <span class="info-responsible-title">Responsável:</span> 
                                            {{responsible.owner.name}}
                                        </div>
                                        <div class="tell">
                                            <span class="info-responsible-title">Telefone: </span>
                                            {{responsible.owner.tel}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </ui-popover>
                    </div>
                </div>

                <div class="absent-gift">
                    <ui-button design="danger mw-150 md" @click="registerCheckin('ausente')">
                        Cliente Ausente
                    </ui-button>

                    <ui-button design="success mw-150 md" @click="registerCheckin('presente')">
                        Cliente Presente
                    </ui-button>
                </div>
            </div>
        </div>

        <div class="button-panel">
            <ui-button :loading="load" design="mw-200 primary md" @click="call">
                <span class="icon-button-panel"><em class="fal fa-tv" /></span>
                Chamar no painel
            </ui-button>
        </div>
    </ui-modal>
</template>

<script>
    import { uiTagIndicator } from '@/components/ui/tags'
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
    import { uiLoadIndicator, uiPopover } from '@/components/ui'

    import { launchDay } from '@/services/axios'

    import { modalMixin } from '@/mixins'
    import { phoneMask, documentBr } from '@/filters'

    import { mapGetters } from 'vuex'

    export default {
        name: 'call-customer-modal',

        components: {
            uiModal,
            uiTagIndicator,
            uiButton,
            uiLoadIndicator,
            uiPopover
        },

        filters: { phoneMask, documentBr },

        mixins: [modalMixin],

        props: {
            name: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                deal: null,
                load: true
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                definitions: 'getDefinitions'
            }),
            /**
             * Computed property que formata os dados do responsável pelo negócio/cliente
             */
            responsible() {
                let treeOwner = { 
                    team: '-',
                    users: []
                }

                if (this.deal && this.deal.owners) {
                    if (this.deal.owners.team) {
                        treeOwner.team = this.deal.owners.team.name
                    }

                    if (this.deal.owners.broker && this.deal.owners.broker.user) {
                        treeOwner.users.push( {
                            group: 'Corretor',
                            name: this.deal.owners.broker.user.first_name || '-',
                            tel: this.tell(this.deal.owners.broker.user)
                            }
                        )
                    }

                    if (this.deal.owners.manager && this.deal.owners.manager.user) {
                        treeOwner.users.push({
                            group: 'Gerente',
                            name: this.deal.owners.manager.user.first_name || '-',
                            tel: this.tell(this.deal.owners.manager.user)
                        })
                    }

                    if (this.deal.owners.owner) {
                        treeOwner.owner = {
                            name: this.deal.owners.owner.first_name || '-',
                            tel: this.tell(this.deal.owners.owner)
                        }
                    }
                }

                return treeOwner
            }
        },

        mounted() {
            this.$root.$on('modal-open-call-customer', (payload) => {
                this.deal = { ...payload }
                this.load = false
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-call-customer')
        },

        methods: {
            /**
             * caso não exista celular traz telefone
             */
            tell(tell) {
                return tell.mobile ? tell.mobile : tell.phone ? tell.phone : '-'
            },
            /**
             * Recebe um número de telefone/celular como parâmetro e o formata de acordo
             */
            formatPhone(phone) {
                let formatted = 'Sem contato'
                // Caso o número já esteja no formato correto, retorna sem formatar
                if (phone) formatted = (phone | phoneMask) || phone

                return formatted
            },
            /**
             * Função que cadastra um checkin para o cliente de acordo com a situação
             * deste durante a chamada
             */
            registerCheckin(situation) {
                const params = {
                    model: 'Deal_Main',
                    id: this.deal.id,
                    points_id: this.definitions.launchday_point_id,
                    situation
                }
                this.load = true
                launchDay.create('checkin', params)
                    .then(response => {
                        if (response.data.msg) this.$toastr.s(response.data.msg)
                        this.$root.$emit('modal-close-call-customer')
                        this.$root.$emit('take-along-last-row-launchday')
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                        this.load = false
                    })
            },
            /**
             * Realiza uma requisição de modo a enviar, via socket, os dados do cliente atual
             * para a lista de chamadas
             */
            call() {
                this.load = true
                launchDay.get('call-customer', this.deal.id, {})
                    .then(() => {
                        this.$toastr.s('Cliente chamado com sucesso!')
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.load = false
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>